import C from '../../../constants';

import PolyUtil from '../../../util/PolyUtil';
import {setCoordinateGroup} from './tenant';
import {SubmissionError} from "redux-form";
import {hideModal} from "../../../store/actions/display";

export const setRoommateGroup = (group) => ({
    type: C.SET_TENANT_ROOMMATE_GROUP,
    payload: group
});

export const setInvitations = (invitations) => ({
    type: C.SET_TENANT_INVITATIONS,
    payload: invitations
});

export const setListingPreferences = (prefs) => ({
    type: C.SET_TENANT_LISTING_PREFERENCES,
    payload: prefs
});

export const setTenantRecommendedListings = (listings) => ({
    type: C.SET_TENANT_RECOMMENDED_LISTINGS,
    payload: listings
});

export const fetchRoommateGroup = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setRoommateGroup(data));
    }).catch((error) => {
        if (error.detail === 'Not found.') {
            return dispatch(setCoordinateGroup());
        } else {
            console.log('Error: ', error);
        }
    });
};

export const fetchInvitations = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/invitations/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setInvitations(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchListingPreferences = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/listing-preferences/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setListingPreferences(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchRecommendedListings = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/recommended-listings/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setTenantRecommendedListings(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleAddInvite = (data) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/unlock/',
        {method: "POST"}
    ).then(() => {
        return PolyUtil.fetchWrapper('/api/tenant/roommate-group/invite-roommate/',
            {
                method: 'POST',
                body: JSON.stringify(data)
            }
        );
    }).then(() => {
        return dispatch(fetchRoommateGroup());
    }).catch((error) => {
        console.log('Error: ', error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleRemoveRoommate = (first_name, last_name, email) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/unlock/',
        {method: "POST"}
    ).then(() => {
        return PolyUtil.fetchWrapper('/api/tenant/roommate-group/remove-roommate/',
            {
                method: 'POST',
                body: JSON.stringify({
                    first_name: first_name,
                    last_name: last_name,
                    email: email
                })
            }, 'no-cors'
        );
    }).then(() => {
        return PolyUtil.fetchWrapper('/api/tenant/roommate-group/',
            {method: 'GET'}
        );
    }).then((data) => {
        return dispatch(setRoommateGroup(data));
    }).catch((error) => {
        console.log('Error: ', error);
    });
};

export const handleRejectInvitation = (id) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/invitations/' + id + '/dedline/',
        {method: 'POST'}
    ).then(() => {
        return dispatch(fetchInvitations());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleAcceptInvitation = (id) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/invitations/' + id + '/accept/',
        {method: 'POST'}
    ).then(() => {
        return dispatch(fetchRoommateGroup());
    }).then(() => {
        return dispatch(fetchInvitations());
    }).catch((error) => {
        console.log('Error: ', error);
    });
};

export const handleLeaveGroup = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/leave/',
        {method: 'POST'}
    ).then(() => {
        return dispatch(fetchRoommateGroup());
    }).then(() => {
        return dispatch(hideModal('manage_group_modal'));
    }).catch((error) => {
        console.log("Error:", error);
    });
};

export const handleUpdateListingPreferences = (preferences) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/roommate-group/listing-preferences/',
        {
            method: 'PUT',
            body: JSON.stringify(preferences)
        }
    ).then(() => {
        return dispatch(fetchListingPreferences());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};




// WEBPACK FOOTER //
// ./src/containers/tenant/actions/roommates.js